import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ENABLE_HELPJUICE_KNOWLEDGE_BASE } from "../member/chase-detail/chase-detail-chart/attributes";
import { ServiceOrgConfigurationService } from "../service-org-admin/service-org-config/service-org-config.service";

@Injectable({
  providedIn: "root",
})
export class KnowledgeBaseAccessGuard implements CanActivate {
  constructor(
    private readonly serviceOrgConfigurationService: ServiceOrgConfigurationService,
    private readonly router: Router
  ) { }

  canActivate(): Observable<boolean> {
    return this.serviceOrgConfigurationService
      .getServiceOrgConfigurationByAttribute(ENABLE_HELPJUICE_KNOWLEDGE_BASE.attributeId)
      .pipe(
        map(config => {
          const isEnabled = Boolean(Number(config?.attributeValue));
          if (!isEnabled) {
            this.router.navigate(["403"]);
          }
          return isEnabled;
        }),
        catchError(() => {
          this.router.navigate(["403"]);
          return of(false);
        })
      );
  }
}
